import React from "react";
import { useDispatch } from "react-redux";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { cleanSearchingModuleConfigurationsPaginated, moduleConfigurationCleanSearchText, moduleConfigurationSetSearchText, startSearchingModuleConfigurationsPaginated } from "../../app/actions/moduleConfigurationActions";
import { debugLogPages } from "../../app/helpers/debugHelper";

const SearchBackModuleConfiguration = ({ searchText, setSearchText, itemsPerPage, setIsDisabledSearchText, isDisabledSearchText, setIsDisabledFilter, isDisabledFilter }) => {
  debugLogPages(":: SearchBackModuleConfiguration");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      setIsDisabledFilter(true);
      setIsDisabledSearchText(false);

      trackEvent({ component: "SearchModuleConfigurations", event: "SearchModuleConfigurations-Clicked", search: event.target.value });

      dispatch(moduleConfigurationSetSearchText(event.target.value));

      dispatch(startSearchingModuleConfigurationsPaginated(event.target.value, 0, itemsPerPage));
    } else {
      setIsDisabledFilter(false);
      setIsDisabledSearchText(false);
      
      dispatch(cleanSearchingModuleConfigurationsPaginated());

      dispatch(moduleConfigurationCleanSearchText());
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
            disabled={isDisabledSearchText}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackModuleConfiguration;
